import React from "react";
import { Icon } from "@vitalsource/vstui";

class TrendingIcon extends React.PureComponent {
  render() {
    return (
      <Icon {...this.props} width={60} height={34}>
        <path
          d="M58.014.875l1.06 13.923-4.195.262-.556-7.313-20.084 24.291-.141.154a2.512 2.512 0 01-3.37.132l-.137-.124-.12-.126-12.063-13.946-15.379 15.7L.172 31.03l16.536-16.88c.928-.923 2.4-.97 3.386-.14l.13.118.121.128L32.313 28.09 50.725 5.822l-7.254.928-.619-3.938L58.014.875zm-1.67 4.428l-.184.224.563 7.413.203-.013-.581-7.624zm-.165-2.179l-.2.026.072.95.216.179-.088-1.155z"
          fill="#D2D9ED"
          fillRule="nonzero"
        />
      </Icon>
    );
  }
}

TrendingIcon.displayName = "TrendingIcon";
TrendingIcon.vstuiName = "Icon";

export default TrendingIcon;
